import { useMutation, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { IMarkReadMessageOnMutationArguments, IMessage } from '../graphQlSchema';
import { MESSAGE_INBOX_QUERY } from './queries';

const MARK_AS_READ = gql`
  mutation MarkRead($id: ID!) {
    markReadMessage(id: $id) {
      id
      readAt
    }
  }
`;

export const useMessageInbox = () => {
  const messages = useQuery<{ messages: IMessage[] }>(MESSAGE_INBOX_QUERY);
  const [setMarkReadMessage] = useMutation<{ markReadMessage: IMessage }, IMarkReadMessageOnMutationArguments>(
    MARK_AS_READ
  );

  return [messages, (variables: IMarkReadMessageOnMutationArguments) => setMarkReadMessage({ variables })] as const;
};
